import { render, staticRenderFns } from "./ElemMask.vue?vue&type=template&id=63dc29fa&"
import script from "./ElemMask.vue?vue&type=script&lang=js&"
export * from "./ElemMask.vue?vue&type=script&lang=js&"
import style0 from "./ElemMask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports